import axios from 'axios';
import { supabase } from '../config/supabase';

/* ================= BASE URL ================= */
// Development: localhost:5000 | Production: pharmaempower.com
const API_BASE_URL = (
  process.env.REACT_APP_API_URL ||
  (process.env.NODE_ENV === 'production'
    ? 'https://pharmaempower.com'
    : 'http://localhost:5000')
).replace(/\/$/, '');

console.log('API Base URL:', API_BASE_URL);

const api = axios.create({
  baseURL: API_BASE_URL,
  withCredentials: false,
});

/* ================= TOKEN INTERCEPTOR (SUPABASE) ================= */
api.interceptors.request.use(
  async (config) => {
    // Get token from Supabase session
    const { data: { session } } = await supabase.auth.getSession();
    if (session?.access_token) {
      config.headers.Authorization = `Bearer ${session.access_token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

/* ================= AUTH (Using Supabase directly - these are legacy) ================= */
export const authAPI = {
  register: (data) => api.post('/api/auth/register', data),
  login: (data) => api.post('/api/auth/login', data),
};

/* ================= SKILLS ================= */
export const skillAPI = {
  getAll: () => api.get('/api/skills'),
  getUserSkills: () => api.get('/api/skills/my-skills'),
  updateUserSkill: (data) => api.post('/api/skills/my-skills', data),
};

/* ================= COMMUNITY ================= */
export const communityAPI = {
  getQA: () => api.get('/api/community/public'),

  askQuestion: (data) =>
    api.post('/api/community/ask', {
      name: data.name,
      query: data.query,
    }),

  getAllAdmin: () => api.get('/api/admin/community/pending'),
  answerQuestion: (id, data) =>
    api.put(`/api/admin/community/answer/${id}`, data),
};

/* ================= USERS ================= */
export const userAPI = {
  getAllUsers: () => api.get('/api/users'),
  updateUserRole: (id, role) =>
    api.put(`/api/users/${id}/role`, { role }),
  updateUserStatus: (id, is_blocked) =>
    api.put(`/api/users/${id}/status`, { is_blocked }),
};

/* ================= CMS ================= */
export const cmsAPI = {
  getPage: (slug) => api.get(`/api/pages/${slug}`),
  updatePage: (slug, data) => api.put(`/api/pages/${slug}`, data),
};

/* ================= VIDEO ================= */
export const videoAPI = {
  getAll: () => api.get('/api/video'),
  add: (data) => api.post('/api/video', data),
};

/* ================= ADMIN ================= */
export const adminAPI = {
  addPatient: (data) => api.post('/api/admin/addpatient', data),
  sendNotification: (data) => api.post('/api/admin/notification', data),
  getNotifications: () => api.get('/api/admin/notification'),
};

/* ================= CALENDAR ================= */
export const calendarAPI = {
  createRequest: (data) => api.post('/api/calendar/requests', data),
  getAdminRequests: () => api.get('/api/calendar/admin/requests'),
  updateStatus: (data) =>
    api.put('/api/calendar/admin/update-status', data),
};

/* ================= APPOINTMENT ================= */
export const appointmentAPI = {
  takeAppointment: (data) => api.post('/api/appointment', data),
  getAllAppointments: () => api.get('/api/appointment'),
  deleteAppointment: (id) => api.delete(`/api/appointment/${id}`),
};

/* ================= EVENTS ================= */
export const eventAPI = {
  getAll: () => api.get('/api/events'),
  create: (data) => api.post('/api/events', data),
  getById: (id) => api.get(`/api/events/${id}`),
  update: (id, data) => api.put(`/api/events/${id}`, data),
  delete: (id) => api.delete(`/api/events/${id}`),
};

/* ================= JOBS ================= */
export const jobAPI = {
  getAll: () => api.get('/api/jobs'),
  create: (data) => api.post('/api/jobs', data),
  update: (id, data) => api.put(`/api/jobs/${id}`, data),
  delete: (id) => api.delete(`/api/jobs/${id}`),
};

/* ================= CHAT ================= */
export const chatApi = {
  sendChat: (message) => api.post('/api/chat', message),
  getChat: () => api.get('/api/chat'),
};

/* ================= ENQUIRY ================= */
export const inquiryAPI = {
  createInquiry: (data) => api.post('/api/enquiries', data),
  getAllEnquiries: () => api.get('/api/enquiries'),
};

/* ================= NEWS ================= */
export const newsAPI = {
  getNews: () => api.get('/api/news'),
};

/* ================= SESSION ================= */
export const sessionAPI = {
  createSession: (data) => api.post('/api/sessions', data),
  getAllSessions: () => api.get('/api/sessions'),
  deleteSession: (id) => api.delete(`/api/sessions/${id}`),
};

/* ================= CONTACT ================= */
export const contactAPI = {
  sendMessage: (data) => api.post('/api/contact', data),
  getAll: () => api.get('/api/contact'),
  markAsRead: (id) => api.put(`/api/contact/${id}/read`),
};

/* ================= DASHBOARD ================= */
export const dashboardAPI = {
  getStats: () => api.get('/api/admin/dashboard/stats'),
};

/* ================= ADMIN SETTINGS ================= */
export const adminSettingsAPI = {
  getProfile: () => api.get('/api/admin/settings/profile'),
  updateProfile: (data) => api.put('/api/admin/settings/profile', data),
  changePassword: (data) => api.put('/api/admin/settings/password', data),
};

/* ================= NOTIFICATIONS ================= */
export const notificationAPI = {
  getAll: (params) => api.get('/api/notifications', { params }),
  getUnreadCount: () => api.get('/api/notifications/unread-count'),
  markAsRead: (id) => api.put(`/api/notifications/${id}/read`),
  markAllAsRead: () => api.put('/api/notifications/read-all'),
};


export const adminAuthAPI = {
  changePassword: (data) =>
    api.put('/api/auth/admin/change-password', data),
};
export default api;
